<div class="loading-spinner" [class]="loaderClass">
  <mat-spinner [diameter]="spinnerDiameter() ?? 50"></mat-spinner>
</div>
